module.exports = __webpack_public_path__ + "media/pyro-p.abc3efb7.webm";